<template>
  <div class="Div">
    <!-- <header1></header1> -->
    <!-- 第一屏 -->
    <div
      class="InitialScreen"
      :style="'height:'+height+''"
    >
    <img class="OneBackImg" :src="ScreenImg" alt="">
      <div class="sb">
        <img
          class="sbImg"
          src="../../../static/image/shubiao.png"
          alt=""
          srcset=""
        >
        <span class="sp1"></span>
        <span class="span"></span>
      </div>
    </div>
    <!-- 学习强国 -->
    <section class="section1">
      <div class="stitle">
        <p class="p">{{list1.classInfo.type_name_cn}}</p>
        <p class="p">{{list1.classInfo.type_name_en}}</p>
        <img
          src="../../../static/image/zhuangshi.png"
          alt=""
        >
      </div>
      <div
        class="content"
        @click="NewsDetail(list1.data[0],38)"
        v-if="list1.data.length>0"
      >
        <div class="left">
          <img
            class="backUrl"
            src="../../../static/image/9-2.png"
            alt=""
          >
          <img
            class="img"
            :src="list1.data[0].article_img"
            alt=""
          >
        </div>
        <div class="right">
          <p
            class="title ellipsis2"
            :title="list1.data[0].article_title_cn"
          >
            {{list1.data[0].article_title_cn}}
          </p>

          <p class="summary ellipsis4">
            {{list1.data[0].article_describe_cn}}
          </p>
          <p class="time">
            {{list1.data[0].send_time}}
          </p>
          <p class="seeDetail">
            {{list1.viewDetails}} >
          </p>
        </div>
      </div>
      <el-button
        class="more"
        @click="moreNews(list1.classInfo.article_type_id,38)"
      >{{list1.seeMore}}</el-button>
    </section>
    <!-- 先锋示范 -->
    <section class="section2">
      <div class="stitle">
        <p class="p">{{list2.classInfo.type_name_cn}}</p>
        <p class="p">{{list2.classInfo.type_name_en}}</p>
        <img
          src="../../../static/image/zhuangshi.png"
          alt=""
        >
      </div>
      <div class="content" v-if="list2.list.length>0">
        <div
          v-for="(item,i) of list2.list"
          :key="i"
        >
          <div
            class="div"
            v-if="i%2==0"
            key="div"
            @click="NewsDetail(item,39)"
          >
            <img
              class="img"
              :src="item.article_img"
              alt=""
              srcset=""
            >
            <div class="pioneer">
              <div class="date">
                <p class="day">
                  {{item.send_time_day}}
                </p>
                <p class="year">
                  {{item.send_time_ym}}
                </p>
              </div>
              <div
                class="title ellipsis"
                :title="item.article_title_cn"
              >
                {{item.article_title_cn}}
              </div>
              <div class="summary ellipsis4">
                {{item.article_describe_cn}}
              </div>
              <div class="seeDetail">
                {{list2.viewDetails}} >
              </div>
            </div>
          </div>
          <div
            class="div"
            v-else
            key="div"
            @click="NewsDetail(item,39)"
          >
            <div class="pioneer">
              <div class="date">
                <p class="day">
                  {{item.send_time_day}}
                </p>
                <p class="year">
                  {{item.send_time_ym}}
                </p>
              </div>
              <div
                class="title ellipsis"
                :title="item.article_title_cn"
              >
                {{item.article_title_cn}}
              </div>
              <div class="summary ellipsis4">
                {{item.article_describe_cn}}
              </div>
              <div class="seeDetail">
                {{list2.viewDetails}} >
              </div>
            </div>
            <img
              class="img"
              :src="item.article_img"
              alt=""
              srcset=""
            >
          </div>
        </div>
      </div>
      <el-button
        class="more"
        @click="moreNews(list2.classInfo.article_type_id,39)"
      >{{list2.seeMore}}</el-button>
    </section>
    <!-- 党建活动 -->
    <section class="section3">
      <div class="stitle">
        <p class="p">{{list3.classInfo.type_name_cn}}</p>
        <p class="p">{{list3.classInfo.type_name_en}}</p>
        <img
          src="../../../static/image/zhuangshi.png"
          alt=""
        >
      </div>
      <div class="content" v-if="list3.list.length>0">
        <div class="swDiv">
          <swiper
            ref="mySwiper"
            :options="swiperOption"
            class="myswiper"
          >
            <swiper-slide
              class="swiperslide"
               v-for="(item,i) of list3.list"
              :key='i'
            >
              <div
                class="swiperDiv"
                @mouseenter="onEnter"
                @mouseleave="onLeave"
              >
                <!-- @click="swiperClick(i)" -->
                <img
                  class=""
                  :src="item.article_img"
                  alt=""
                  :data-pages='i'
                >
                <div class="title ellipsis" :title="item.article_title_cn"
                :data-pages='i'
              >
                {{item.article_title_cn}}
                </div>
                <div class="time" :data-pages='i'>
                  {{item.send_time}}
                </div>
              </div>
            </swiper-slide>
          </swiper>

        </div>
        <div class="swiper-button-prev"><img
            src="../../../static/image/left.png"
            alt=""
            srcset=""
          ></div>
        <!--左箭头。如果放置在swiper-container外面，需要自定义样式。-->
        <div class="swiper-button-next"><img
            src="../../../static/image/right.png"
            alt=""
            srcset=""
          ></div>
        <!--右箭头。如果放置在swiper-container外面，需要自定义样式。-->
      </div>
      <el-button
        class="more"
        @click="moreNews(list3.classInfo.article_type_id,40)"
      >{{list3.seeMore}}</el-button>
    </section>
    <!-- 工会活动 -->
    <section class="section4">
      <div class="stitle">
         <p class="p">{{list4.classInfo.type_name_cn}}</p>
        <p class="p">{{list4.classInfo.type_name_en}}</p>
        <img
          src="../../../static/image/zhuangshi.png"
          alt=""
        >
        <div class="content" v-if="list4.list.length>0">
          <div
            class="contain"
            v-for="(item,i) of list4.list"
            :key="i"
            @click="NewsDetail(item,41)"
          >
            <img
              class="img"
              :src="item.article_img"
              alt=""
            >
            <div class="title" :title="item.article_title_cn">
              {{item.article_title_cn}}
            </div>
          </div>
        </div>
        <el-button
        class="more"
        @click="moreNews(list4.classInfo.article_type_id,41)"
      >{{list4.seeMore}}</el-button>
      </div>
    </section>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
// import header1 from "../../layout/AppHeader";
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import { learningPower, pioneerDemonstration,partyBuildingActivities,tradeUnionActivities } from "../../api/PartyBuilding";
import {getBanner} from "../../api/home"
export default {
  name: "PartyBuilding",
  data() {
    let _that=this
    return {
      ScreenImg: "",
      height: "", //高度
      warmNum: 0,
      warmHeight: 559,
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        centeredSlides: true,
        effect: "coverflow",
        // grabCursor: true,
        slidesPerView: 2,
        // centeredSlides:true,
        // spaceBetween: -60,
        coverflowEffect: {
          rotate: -20,
          stretch: 10,
          depth: 150,
          modifier: 2,
          slideShadows: false
        },
        // setWrapperSize: true,
        preventClicksPropagation: true,
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        observer: true,
        observeParents: true,
        on: {
          click: function(event) {
            // console.log(
            //   "你点了Swiper",
            //   this.realIndex,
            //   // _that.footBanner[this.realIndex]
            // );
            var index = event.target.getAttribute('data-pages');
            var laber = [0, 8,40, 18];
            var laPath = ["/", "/PartyBuilding","/PartyBuilding"];

            var routeData=_that.$router.resolve({
              path: "/NewsDetails",
              query: {
                laber: JSON.stringify(laber),
                id: _that.list3.list[index].article_id,
                laPath: JSON.stringify(laPath)
              }
            });
            window.open(routeData.href, "_blank");
          }
        }
      }, //swiper参数
      list1: { classInfo: {}, data: [{ article_img: "" }] }, //学习强国
      list2: { classInfo: {}, list: [{ article_img: "" }] }, //先锋示范
      list3: { classInfo: {}, list: [{ article_img: "" }] }, //党建活动
      list4: { classInfo: {}, list: [{ article_img: "" }] } //工会活动
    };
  },

  computed: {
    ...mapState("user", ["headerHeight"]),
    swiper() {
      return this.$refs.mySwiper.$swiper;
    }
  },
  components: {
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  methods: {
    // 监听浏览器高度宽度变化
    getHeight() {
      //   console.log(this.headerHeight, "dfsf");
      this.height = window.innerHeight - this.headerHeight + "px";
    },
    swiperClick(i) {
      // console.log(i);
    },
    // 鼠标移入暂停循环轮播
    onEnter() {
      this.swiper.autoplay.stop();
    },
    onLeave() {
      if (this.swiper.autoplay) {
        this.swiper.autoplay.start();
      }
    },
    // 跳转党建列表
    moreNews(index,x) {
      var laber = [0, 8,x, 17];
      var laPath = ["/", "/PartyBuilding", "/PartyBuilding"];
      this.$router.push({
        path: "/RecruitmentList",
        query: {
          laber: JSON.stringify(laber),
          laPath: JSON.stringify(laPath),
          uid: index
        }
      });
    },
    // 新闻详情
    NewsDetail(item,x) {
      var laber = [0, 8,x, 18];
      var laPath = ["/", "/PartyBuilding","/PartyBuilding"];
      //
      var routeData=this.$router.resolve({
        path: "/NewsDetails",
        query: {
          laber: JSON.stringify(laber),
          id: item.article_id,
          laPath: JSON.stringify(laPath)
        }
      });
      window.open(routeData.href, "_blank");
    }
  },
  created() {
    // 第一屏banner
    getBanner({
      address:12
    }).then(res=>{
      this.ScreenImg=res.data.banner_img
    })
    // 学习强国
    learningPower({
      limit: 1
    }).then(res => {
      // console.log(res.data)
      this.list1 = res.data;
    });
    // 先锋示范
    pioneerDemonstration({
      limit: 2
    }).then(res => {
      // console.log(res.data);
      this.list2 = res.data;
    });
    // 党建活动
    partyBuildingActivities({
      limit: 5
    }).then(res => {
      // console.log(res.data);
      this.list3 = res.data;
    });
    // 工会活动
    tradeUnionActivities({
      limit: 2
    }).then(res => {
      // console.log(res.data);
      this.list4 = res.data;
    });

  },
  mounted() {
    window.addEventListener("resize", this.getHeight);
    this.getHeight();

    // this.warmHeight=this.$refs.warmheight.offsetHeight+'px';
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight);
  }
};
</script>
<style lang="scss" scoped>
@import "../../assets/custom/common.scss";
.InitialScreen {
  position: relative;
  width: 100%;
  //   height: 79.5vh;
  background-size: cover;
  padding-top: 0.1px;
  &::before {
    display: block;
    position: absolute;
    content: "";
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 1;
    top: 0;
    left: 0;
  }
  .overview {
    position: relative;
    margin-left: 16.1%;
    margin-top: 5%;
    z-index: 1;
    text-align: left;
    .title {
      position: relative;
      font-size: px2Rem(80px);
      // font-family: "STXinwei";
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      cursor: pointer;
      span {
        vertical-align: middle;
      }
      &::before {
        display: block;
        position: absolute;
        content: "";
        width: px2Rem(100px);
        height: px2Rem(4px);
        bottom: px2Rem(-30px);
        left: px2Rem(10px);
        border-radius: 2px;
        background-color: #fff;
      }
    }
    .overImg {
      width: px2Rem(38px);
      height: px2Rem(38px);
      margin-left: px2Rem(15px);
    }
    .caption {
      width: px2Rem(707px);
      margin-top: px2Rem(70px);
      font-size: px2Rem(28px);
      // font-family: STXinwei;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: px2Rem(35px);
    }
    .btn {
      padding: px2Rem(19px) px2Rem(68px);
      margin-top: px2Rem(60px);
      border: 2px solid rgba(255, 255, 255, 1);
      border-radius: 4px;
      font-size: px2Rem(24px);
      // font-family: STXinwei;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      background: rgba(0, 0, 0, 0);
      transition: 0.3s;
      &:hover {
        background: rgba(255, 255, 255, 0.3);
      }
    }
  }
}

.section1 {
  margin: px2Rem(60px) auto;
  .content {
    width: px2Rem(1300px);
    padding-bottom: px2Rem(40px);
    margin: px2Rem(30px) auto 0;
    cursor: pointer;
    .left {
      position: relative;
      display: inline-block;
      width: px2Rem(720px);
      height: px2Rem(450px);
      vertical-align: top;
      .backUrl {
        position: absolute;
        display: block;
        width: 100%;
        height: 100%;
      }
      .img {
        display: block;
        position: relative;
        margin: px2Rem(10px);
        width: px2Rem(700px);
        height: px2Rem(430px);
      }
    }
    .right {
      position: relative;
      display: inline-block;
      width: px2Rem(560px);
      top: px2Rem(40px);
      margin-left: px2Rem(15px);
      cursor: pointer;

      .title {
        font-size: px2Rem(28px);
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }
      .time {
        margin: px2Rem(33px) 0 px2Rem(60px);
        font-size: px2Rem(20px);
        font-weight: 400;
        color: #aeaeae;
      }
      .summary {
        height: px2Rem(125px);
        // margin-bottom: px2Rem(10px);
        margin-top: px2Rem(35px);
        font-size: px2Rem(24px);
        font-weight: 400;
        color: #6c6c6c;
        -webkit-line-clamp: 5;
        line-clamp: 5;
        line-height: px2Rem(26px);
      }
      .seeDetail {
        font-size: px2Rem(24px);
        font-weight: 400;
        color: #aeaeae;
      }
    }
    &:hover {
      .title,
      .seeDetail {
        color: #1c3278;
      }
    }
  }
}
.section2 {
  padding: px2Rem(60px) 0;
  background: #f5f5f5;
  .content {
    width: px2Rem(1300px);
    padding-bottom: px2Rem(40px);
    margin: px2Rem(30px) auto 0;
    font-size: 0;
    .div {
      height: px2Rem(400px);
      font-size: 0;
      cursor: pointer;
    }
    .img {
      display: inline-block;
      width: px2Rem(648px);
      height: 100%;
      vertical-align: top;
    }
    .pioneer {
      display: inline-block;
      width: px2Rem(590px);
      height: 100%;
      padding: 0 px2Rem(30px);
      background: rgba(255, 255, 255, 1);
      
      &:hover {
        .title {
          color: #1c3278;
        }
        .seeDetail{
          color: #1c3278;
        }
      }
      .date {
        width: px2Rem(90px);
        height: px2Rem(90px);
        background: rgba(28, 50, 120, 1);
        border-radius: 0px 0px 8px 8px;
        text-align: center;
        .day {
          margin: px2Rem(0px) px2Rem(10px) 0;
          padding-top: px2Rem(5px);
          border-bottom: 1px dashed #fff;
          font-size: px2Rem(54px);
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
        }
        .year {
          padding-top: px2Rem(8px);
          font-size: px2Rem(16px);
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
        }
      }
      .title {
        margin: px2Rem(20px) 0 px2Rem(30px);
        font-size: px2Rem(28px);
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }
      .summary {
        height: px2Rem(120px);
        line-height: px2Rem(30px);
        font-size: px2Rem(24px);
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
      }
      .seeDetail{
        margin-top: px2Rem(60px);
        font-size: px2Rem(24px);
        font-weight: 400;
        color: #aeaeae;
      }
    }
  }
}
.section3 {
  padding: px2Rem(60px) 0;
  .content {
    position: relative;
    width: px2Rem(1300px);
    padding-bottom: px2Rem(40px);
    margin: px2Rem(30px) auto 0;
    font-size: 0;
    .swDiv {
      width: px2Rem(1100px);
      margin: auto;
    }
    .swiperDiv {
      width: px2Rem(500px);
      height: px2Rem(400px);
      text-align: center;
      cursor: pointer;
      img {
        display: block;
        width: 100%;
        height: px2Rem(310px);
      }
      .title {
        margin: px2Rem(20px) 0;
        font-size: px2Rem(28px);
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }
      .time {
        font-size: px2Rem(20px);

        font-weight: 400;
        color: rgba(153, 153, 153, 1);
      }
      &:hover{
        .title{
          color: rgba(28, 50, 120, 1)
        }
      }
    }
    .swiper-button-next,
    .swiper-button-prev {
      width: px2Rem(54px);
      height: px2Rem(54px);
      top: 42%;
      outline: none;
      &::after {
        display: none;
      }
      border-radius: 51%;
      transition: 0.5s;
      &:hover {
        background: rgba(28, 50, 120, 0.1);
      }
      img {
        width: px2Rem(54px);
        height: px2Rem(54px);
      }
    }
    .swiper-button-next {
      right: 1px;
    }
    .swiper-button-prev {
      left: 1px;
    }
  }
}
.section4 {
  padding: px2Rem(60px) 0 px2Rem(120px);
  background: #f5f5f5;
  .content {
    width: px2Rem(1300px);
    padding-bottom: px2Rem(40px);
    margin: px2Rem(30px) auto 0;
    font-size: 0;
    .contain {
      display: inline-block;
      position: relative;
      width: px2Rem(635px);
      padding-bottom: px2Rem(20px);
      margin-bottom: px2Rem(10px);
      vertical-align: top;
      cursor: pointer;
      top: 0;
      transition: .5s;
      &:hover {
        // top: px2Rem(-15px);
        box-shadow:0px 0px 9px 0px rgba(0, 0, 0, 0.3);
        .title {
          color: #1c3278;
        }
      }
      &:nth-of-type(2n-1) {
        margin-right: px2Rem(28px);
      }
      .img {
        width: 100%;
        height: px2Rem(388px);
      }
      .title {
        margin-top: px2Rem(20px);
        font-size: px2Rem(28px);
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        text-align: center;
      }
    }
  }
}
.more {
  display: block;
  margin: px2Rem(10px) auto 0px;
  padding: px2Rem(20px) px2Rem(68);
  border: 1px solid rgba(28, 50, 120, 1);
  border-radius: 4px;
  font-size: px2Rem(24px);
  // font-family: STXinwei;
  background: rgba(0, 0, 0, 0);
  font-weight: 400;
  color: rgba(28, 50, 120, 1);
  transition: 0.3s;
  &:hover {
    background: rgba(28, 50, 120, 0.5);
    color: #fff;
    border: 1px solid #fff;
  }
}
.title {
  z-index: 1;
}
</style>


// WEBPACK FOOTER //
// src/views/PartyBuilding/Index.vue